/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { StyleSheet, css } from 'aphrodite';

import { BrandColors, MaterialIcon, Mixins, Text } from '@blend/enterprise-components';
import { wideCardWidth } from 'blb-styles/constants';

export const styles = StyleSheet.create({
  container: {
    backgroundColor: BrandColors.WHITE,
    borderRadius: 3,
    marginBottom: 50,
    padding: 32,
    ...Mixins.border(BrandColors.CLOUD_50, 1, 'solid'),

    maxWidth: wideCardWidth,
  },
  content: {
    alignItems: 'center',
    backgroundColor: BrandColors.BACKGROUND_GREY,
    display: 'flex',
    minHeight: 50,

    padding: '0 32px',
    width: '100%',
  },
  textWrapper: {
    paddingLeft: 10,
  },
});

interface UnavailableMessageProps {
  message: string;
}

export const UnavailableMessage: React.FC<UnavailableMessageProps> = ({ message }) => {
  return (
    <div className={css(styles.container)}>
      <div className={css(styles.content)}>
        <MaterialIcon color={BrandColors.NIGHT_60} size={22} type="info" />
        <div className={css(styles.textWrapper)}>
          <Text color={BrandColors.NIGHT_60} data-it="UnavailableMessage-Text">
            {message}
          </Text>
        </div>
      </div>
    </div>
  );
};
